import { Entity } from './entity.js';
import { structureDamageBlockResult } from './combat/structureDamageGate.js';

export class Turret extends Entity {
  constructor({ id, team = 'blue', x = 0, y = 0, z = 0, hp = 2500, maxHp = 2500, ad = 152, attackRange = 775, as = 0.833 }) {
    super({
      id,
      name: `Torreta ${team === 'blue' ? 'Azul' : 'Roja'}`,
      type: 'turret',
      team,
      x,
      y,
      z,
      radius: 40,
      ms: 0,
      attackRange,
      as,
      ad,
      hp,
      maxHp,
      bounty: 250
    });

    this.aggroTarget = null;
    this.hasTargetAlert = false;
  }

  takeDamage(amount, sourceEntity = null, damageType = 'physical', isCrit = false) {
    const blocked = structureDamageBlockResult(this);
    if (blocked) return blocked;
    return super.takeDamage(amount, sourceEntity, damageType, isCrit);
  }

  static isKillableWithAttack(minionEntity, attackerAd) {
    if (!minionEntity || minionEntity.isDead) return false;
    return minionEntity.hp <= attackerAd;
  }

  // Revelación de Visión Verdadera (True Sight) de Torreta
  providesTrueSight(targetEntity) {
    if (this.isDead || !targetEntity || targetEntity.isDead) return false;
    if (targetEntity.team === this.team) return true;
    const rangeUnits = this.attackRange / 100;
    const dist = Math.hypot(targetEntity.x - this.x, targetEntity.z - this.z);
    return dist <= (rangeUnits + targetEntity.radius / 16);
  }

  // Prioridad de Agro de Torreta Oficial LoL y Asignación de Objetivo de Ataque
  updateTurretAggro(allEntities = [], recentDamageEvents = []) {
    if (this.isDead) {
      this.aggroTarget = null;
      this.attackTarget = null;
      this.isAttacking = false;
      this.hasTargetAlert = false;
      return null;
    }

    const rangeUnits = this.attackRange / 100;

    const inRangeEnemies = allEntities.filter(e => {
      if (!e || e.isDead || e.team === this.team) return false;
      const dist = Math.hypot(e.x - this.x, e.z - this.z);
      return dist <= (rangeUnits + e.radius / 16);
    });

    // 1. Alerta de Agro: Enemigo que atacó a un aliado dentro de la cobertura
    const attackerEvent = recentDamageEvents.find(evt => {
      if (!evt.attacker || !evt.victim) return false;
      if (evt.attacker.team !== this.team && evt.victim.team === this.team) {
        const distAttacker = Math.hypot(evt.attacker.x - this.x, evt.attacker.z - this.z);
        return distAttacker <= rangeUnits;
      }
      return false;
    });

    if (attackerEvent) {
      this.aggroTarget = attackerEvent.attacker;
      this.attackTarget = this.aggroTarget;
      this.isAttacking = true;
      this.hasTargetAlert = true;
      return this.aggroTarget;
    }

    // 2. Si la torreta ya tiene un objetivo válido en rango
    if (this.aggroTarget && !this.aggroTarget.isDead && inRangeEnemies.includes(this.aggroTarget)) {
      this.attackTarget = this.aggroTarget;
      this.isAttacking = true;
      this.hasTargetAlert = this.aggroTarget.type === 'champion';
      return this.aggroTarget;
    }

    // 3. Súbditos enemigos (priorizar minion más cercano)
    const inRangeMinions = inRangeEnemies.filter(e => e.type && e.type.startsWith('minion'));
    if (inRangeMinions.length > 0) {
      inRangeMinions.sort((a, b) => Math.hypot(a.x - this.x, a.z - this.z) - Math.hypot(b.x - this.x, b.z - this.z));
      this.aggroTarget = inRangeMinions[0];
      this.attackTarget = this.aggroTarget;
      this.isAttacking = true;
      this.hasTargetAlert = false;
      return this.aggroTarget;
    }

    // 4. Campeones enemigos
    const inRangeChamps = inRangeEnemies.filter(e => e.type === 'champion');
    if (inRangeChamps.length > 0) {
      this.aggroTarget = inRangeChamps[0];
      this.attackTarget = this.aggroTarget;
      this.isAttacking = true;
      this.hasTargetAlert = true;
      return this.aggroTarget;
    }

    this.aggroTarget = null;
    this.attackTarget = null;
    this.isAttacking = false;
    this.hasTargetAlert = false;
    return null;
  }
}
